import resolve from "ng";

export default (checkPromise, timeout = 600000, interval = 5000) => {
  const endTime = Number(new Date()) + timeout;
  const $timeout = resolve("$timeout");
  const $q = resolve("$q");
  const deferred = $q.defer();
  const elapsed = () =>
    checkPromise()
      .then(result => {
        if (result) {
          deferred.resolve(result);
        } else if (Number(new Date()) < endTime) {
          $timeout(elapsed, interval);
        }
        // Didn't match and too much time, reject!
        else {
          deferred.reject(new Error("Timeout expired"));
        }
      })
      .catch(deferred.reject);

  elapsed();

  return deferred.promise;
};
